import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=8193865e&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=8193865e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8193865e",
  null
  
)

export default component.exports